import React from 'react';
import Icon from './icons/Icon';

export const DisabledBanner = ({ message = 'Event Deactivated' }) => (
  <div className="notification-strip__disabled">
    <Icon icon="Lock" className="notification-strip__icon" />
    <p className="notification-strip__message">{message}</p>
  </div>
);
